// extracted by mini-css-extract-plugin
module.exports = {"couponCard":"styles-module__couponCard___2SXQI","actionButton":"styles-module__actionButton___pFLOR"};